import { IOffer } from '../../../types/offer';

export function isCoworking(offer: IOffer): boolean {
  return Boolean(offer.coworkingOfferType) || Boolean(offer.coworking);
}
